import { useEffect, useState } from "react"
import { RequestConfigs } from "../../api"
import { CheckoutLayout } from "../../components/checkout/CheckoutLayout"
import { useFormHandling } from "../../hooks/formUtils"
import { BoxContainer, Col, Row, Text, VImage } from "../../style/base.style"
import { useNavigate } from "react-router-dom"
import { routesMap } from "../../constants/routes"
import { useContactType } from "../../contexts/ContactContext"
import { calculateAge } from "../../utils/calculators"
import { all } from "axios"
import { TableColumn, TableComponent } from "../../components/common/TableComponent"
import { translate } from "react-range/lib/utils"
import { useDictionary } from "../../contexts/dictionary"
import { FormComponent } from "../../components/form"
import { FieldConfig, FieldType, TextFieldType } from "../../components/fields"
import Joi from "joi"
import { useDeviceType } from "../../contexts/DeviceContext"
import { ActionButton } from "../../components/buttons/ActionButton"
import { mastercard, visa } from "../../constants/images"
import { plans } from "../../assets/constant/plans"
import { servicePlans } from "../../assets/constant/services"






export const CheckoutPaymentPage = () => {
    const navigate = useNavigate()
    const {isMobile} = useDeviceType()
    const {cart,contact} = useContactType()
    const {translate} = useDictionary()
    const productId = cart[0]?.product
    console.log("productId",productId)
    const AGE_40 = 40
    const AGE_65 = 65

      useEffect(() => {
            if(!productId){
                navigate(routesMap.checkoutChoosePlan.to)
              }
            handleClick()
            productsForm.handleClick()
        },[])
    
    const {handleClick,serverRes,formValues} = useFormHandling({requestType:RequestConfigs.getFamily})
     const productsForm = useFormHandling({requestType:RequestConfigs.productExtensions,params:{productId:productId}})
    const [family,setFamily] = useState<FamilyMember[]>([])
    



    useEffect(() => {
        handleClick()
    },[])

    useEffect(() => {
        if(serverRes?.family){
            setFamily(serverRes.family)
        }
    },[serverRes])

     const [productExtensions,setProductExtensions] = useState<Product[]>([])
     const [product,setProduct] = useState<Product>()
     const [contacts,setContacts] = useState<any[]>()
     const [allProducts,setAllProducts] = useState<Product[]>([])

      useEffect(() => {
             if(productsForm.serverRes?.productExtensions){
                 setProductExtensions(productsForm.serverRes.productExtensions)
             }
             if(productsForm.serverRes?.product){
                 setProduct(productsForm.serverRes.product)
             }

         },[productsForm.serverRes])

        useEffect(() => {
            if(productExtensions.length > 0 && product && productExtensions.length > 0 && family.length > 0){
                const all = getAllProducts()
                getConractServicesLinks(product.id)
                setAllProducts(all)
            }
        },[productExtensions,product,family,productExtensions])

    const extensions  = productExtensions.sort((a, b) => a.Product_Code.localeCompare(b.Product_Code))

     const getExtension = (familyMember:FamilyMember,kidNumber:number) => {
            const ext = []
            const age = calculateAge(familyMember.Date_of_Birth)
            if(familyMember.family__Is_Guardian){
                if(age.years>AGE_65){
                    const elderExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "65+ Spouse")
                    return elderExtensions
                } if(age.years>AGE_40)  {
                    const spouseExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "40+ Spouse")
                    return spouseExtensions
                } else {
                    const spouseExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "Spouse")
                    return spouseExtensions
                }
    
            } else {
                const firstChildExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "Child")
                return firstChildExtensions
            }
            
        }

        const getConractServicesLinks = (productId:string) => {
            const services = plans.find((item) => item.crmProductId === productId)?.contractServices || []
            const mapped = services.map((item) => {
                const servicePlan = servicePlans.find((service) => service.id === item)
                if(servicePlan){
                    return {
                        name:servicePlan.name,
                        link:`/files/${servicePlan.id}.pdf`,
                    }
                }
                return null
            })
            console.log("mapped",mapped)
            setContacts(mapped)
            return mapped
            
        }

        const getAllProducts = () => {
            let kidNumber = 0
            const allProducts = []
            if(product){
                allProducts.push(product)
            }
            
            const age = calculateAge(contact?.Date_of_Birth)
            if(age.years>AGE_40){
                const elderExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "40+")
                if(elderExtensions){
                    allProducts.push(elderExtensions)
                }
                
            }
            for(let i in family){
                const familyMember = family[i]
                if(!familyMember.family__Is_Guardian){
                    kidNumber+=1
                }
              const ext = getExtension(familyMember,kidNumber)
              if(ext){
                allProducts.push(ext)
              }
              
            }
            
            return allProducts.sort((a, b) => a.Product_Code.localeCompare(b.Product_Code))            
        }

        const paymentFields: FieldConfig[] = [
            {
                type: FieldType.text,
                name: "CardHolderName",
                label: translate("card_holder_name"),
                joiSchema: Joi.string().required(),
                defaultValue: contact?.Full_Name,
                typeOptions: {
                    type: TextFieldType.text,
                }
            },
            {
                type: FieldType.text,
                name: "GovId",
                label: translate("gov_id"),
                joiSchema: Joi.string().required(),
                defaultValue: contact?.payments0__Gov_Id,
                typeOptions: {
                    type: TextFieldType.text,
                }
            },
            {
                type: FieldType.text,
                name: "CardNumber",
                label: translate("card_number"),
                joiSchema: Joi.string().required(),
                typeOptions: {
                    type: TextFieldType.creditCard,
                }
            },
            {
                type: FieldType.text,
                name: "Expiration",
                label: translate("expiry_date"),
                joiSchema: Joi.string().required(),
                typeOptions: {
                    type: TextFieldType.expiration,
                }
            },
            {
                type: FieldType.text,
                name: "CVV",
                label: translate("cvv"),
                joiSchema: Joi.string().required(),
                typeOptions: {
                    type: TextFieldType.number,
                    maxLength: 3,
                }
            },
            {
                type: FieldType.checkBox,
                name: "approveTerms",
                label: translate("approve_terms"),
                joiSchema: Joi.string().required(),
                typeOptions: {
                    Compponent: () => 
                    <Text  $margin="10px 0px" $fontSize="14px" $color="var(--text-color)">{translate("read_and_agree")}
                     <a href={`files/privacy.pdf`} target="_blank" rel="noopener noreferrer" style={{marginLeft: "5px", color: "var(--primary-color)"}}>
                                {translate("terms_and_privacy")}
                            </a>   
                    {translate("contract_services_terms")}

                    (
                    {
                        contacts && contacts.length > 0 &&
                        contacts.map((item, index) => (
                            <a key={index} href={item.link} target="_blank" rel="noopener noreferrer" style={{marginLeft: "5px", color: "var(--primary-color)"}}>
                                {translate(item.name)}{index < contacts.length - 1 ? "," : ""}
                            </a>                
                        ))
                    })
                    </Text>,
                }
            }
        ]

        const columns:TableColumn[] = [
            {
                id:"Product_Name",
                label:translate("description")
            },
          
            {
                id:"Unit_Price",
                label:translate("price"),
                renderCell: (item) => {
                    return (
                        <div>
                            {item.Unit_Price} {item.$currency_symbol}
                        </div>
                    )
                },
                sumAddon:"ILS",
            },
          
        ]
        
    const saleForm = useFormHandling({requestType:RequestConfigs.sale,data:{SaleType:"Recurring",Products:allProducts.map((item)=>(item.id))}})

    useEffect(() => {
        if(saleForm.serverRes?.succeeded){
            navigate(routesMap.checkoutThankYou.to)
        }
    },[
        saleForm.serverRes
    ])

    const handleChange = (name: string, value: any, valid: boolean) => {
       saleForm.handleInputChange(name, value, valid)
       console.log("saleForm",saleForm.formValues)
    }

    const handleClickForm =  () => {
        if(formValues.approveTerms){
            saleForm.handleClick()
        } else {
            saleForm.setServerRes(
                {
                succeeded: false,
                message: translate("approve_terms_error"),
                isLogged: true,
                errorCode: 400,
                cart: [],
                }
        )
        }
    }

    return (
        <CheckoutLayout page="payment">
             <Row $width="100%" $justifyContent="space-between" $alignItems="flex-start" $gap={20}>
                            <Col $width={isMobile?"100%":"60%"} $alignItems="center" $gap={20} >
                            <BoxContainer>
                                {
                                    allProducts.length > 0 &&
                                    <TableComponent
                                        data={allProducts}
                                        columns={columns}
                                        columnToShow={2}
                                        idColumn="Product_Code"
                                        sumRow={true}
                                    />
                                }
                            
                            </BoxContainer>
                           </Col>

                           <Col $width={isMobile?"100%":"35%"} $alignItems="center" $gap={20} >
                            <BoxContainer>
                                <Text $fontSize="18px" $fontWeight={500} $margin="0">{translate("payment")}</Text>
                                <Row>
                                      <VImage src={mastercard} $height="50px" $width="50px"/>
                                    
                                    <VImage src={visa} $height="50px" $width="50px"/>
                                </Row>
                                <FormComponent
                                    fields={paymentFields}
                                    serverRes={saleForm.serverRes}
                                    onChange={handleChange}
                                />
                                <ActionButton width="100%" onClick={handleClickForm} label={translate('pay')} />
                            
                            </BoxContainer>
                           </Col>
            </Row>
        </CheckoutLayout>
    )
}